<template>
  <modal-layout :options="options">
    <styledLanguageSelect class="modal__options">
      <li
        v-for="option in langsList"
        :key="option.l"
        @click="selectLanguage($event, option.l)"
        :class="{ disabled: $i18n.locale === option.l }">
        {{ $t(option.t) }}
      </li>
    </styledLanguageSelect>
  </modal-layout>
</template>

<script>
import ModalLayout from '@/layouts/Modal';
import styled from 'vue-styled-components';
import { mapState } from 'vuex';
import parseAvailableLocales from '@/helpers/parseAvailableLocales';

const styledLanguageSelect = styled('ul', {})`
  li.disabled {
    color: var(--on_primary);
    background-color: var(--primary) !important;
    opacity: 0.5;
    pointer-events: none;
  }
`;

const DEFAULT_AVAILABLE_LOCALES = [
  { l: 'en', t: 'in_english' },
  { l: 'ru', t: 'in_russian' },
  { l: 'uk', t: 'in_ukrainian' },
  { l: 'sw', t: 'in_swahili' },
  { l: 'ja', t: 'in_japanese' },
  { l: 'zh', t: 'in_chinese_simplified' },
  { l: 'zh-hant', t: 'in_chinese' },
];

export default {
  components: { ModalLayout, styledLanguageSelect },
  data() {
    return {
      options: {
        title: 'select-language',
        callbackType: 'LangDialog',
      },
    };
  },

  computed: {
    ...mapState('UI', ['customThemeOptions', 'availableLocales', 'queryLocale']),
    ...mapState(['checkoutOptions']),

    defaultLocales() {
      return this.$i18n.locale === 'en' ? ['en'] : [this.$i18n.locale, 'en'];
    },

    langsList() {
      let data = this.defaultLocales;

      const optionLocales = parseAvailableLocales(
        this.availableLocales,
        this.checkoutOptions?.available_locales,
        DEFAULT_AVAILABLE_LOCALES.map(el => el.l)
      );

      if (optionLocales.length) {
        data = optionLocales;

        if (this.queryLocale || this.checkoutOptions?.locale) {
          const selectedLocale = this.queryLocale || this.checkoutOptions?.locale;

          if (
            DEFAULT_AVAILABLE_LOCALES.map(el => el.l === selectedLocale) &&
            data.some(locale => locale === selectedLocale)
          ) {
            data.push(selectedLocale);
          }
        }
      }

      return DEFAULT_AVAILABLE_LOCALES.filter(el => data.includes(el.l));
    },
  },

  methods: {
    selectLanguage(e, locale) {
      e.stopPropagation();
      this.$bus.$emit('changeLocale', locale);
      this.$bus.$emit(`LangDialogToggle`, false);
    },
  },
};
</script>
